import { render, staticRenderFns } from "./EmpresaNuevoServicio.vue?vue&type=template&id=79056203"
import script from "./EmpresaNuevoServicio.vue?vue&type=script&lang=js"
export * from "./EmpresaNuevoServicio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports